export const EXPEDIENTE_REPORT_STATES = [
  { key: "red", label: "Requieren atención", color: "var(--traffic-red)" },
  { key: "yellow", label: "Próximos", color: "var(--traffic-yellow)" },
  { key: "green", label: "Al día", color: "var(--traffic-green)" },
  { key: "neutral", label: "Sin evaluar", color: "#a7afb8" },
];

export function expedienteReportState(expediente = {}) {
  return ["red", "yellow", "green"].includes(expediente.trafficColor)
    ? expediente.trafficColor
    : "neutral";
}

function validDate(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function donutGradient(states, total) {
  if (!total) return "conic-gradient(#e3e7e8 0deg 360deg)";
  let cursor = 0;
  const stops = states.flatMap((state) => {
    if (!state.count) return [];
    const start = cursor;
    cursor += (state.count / total) * 360;
    return `${state.color} ${start.toFixed(2)}deg ${cursor.toFixed(2)}deg`;
  });
  return `conic-gradient(${stops.join(", ")})`;
}

export function buildExpedientesReport(expedientes = [], {
  now = new Date(),
} = {}) {
  const total = expedientes.length;
  const counts = Object.fromEntries(
    EXPEDIENTE_REPORT_STATES.map(({ key }) => [key, 0]),
  );
  let evaluated = 0;
  let recentActivity = 0;
  const sevenDaysAgo = new Date(now.getTime() - (7 * 24 * 60 * 60 * 1000));

  expedientes.forEach((expediente) => {
    counts[expedienteReportState(expediente)] += 1;
    if (expediente.procedureState?.hasEvaluation) evaluated += 1;
    const activityDate = validDate(expediente.lastActivityAt);
    if (activityDate && activityDate >= sevenDaysAgo && activityDate <= now) {
      recentActivity += 1;
    }
  });

  const states = EXPEDIENTE_REPORT_STATES.map((state) => ({
    ...state,
    count: counts[state.key],
    percentage: total ? Math.round((counts[state.key] / total) * 100) : 0,
  }));

  return {
    total,
    counts,
    states,
    evaluated,
    evaluationCoverage: total ? Math.round((evaluated / total) * 100) : 0,
    recentActivity,
    gradient: donutGradient(states, total),
  };
}
